/**
 * Slim homepage strip pointing at the /free-parties giveaway page (owner
 * chose a banner over a popup, 2026-09-12). Hides itself after the entry
 * deadline so no stale promo lingers on the homepage.
 */

import React from 'react';

import { NamedLink } from '../../../components';
import { isFreePartiesOpen } from '../../FreePartiesPage/freePartiesPromo';

import css from './FreePartiesBanner.module.css';

const FreePartiesBanner = () => {
  if (!isFreePartiesOpen()) {
    return null;
  }
  return (
    <NamedLink name="FreePartiesPage" className={css.root}>
      <span className={css.text}>
        🎉 We're giving away 5 free parties in Santa Barbara County.{' '}
        <span className={css.cta}>Enter by Oct 12 →</span>
      </span>
    </NamedLink>
  );
};

export default FreePartiesBanner;
